module.exports = __webpack_public_path__ + "static/3-63146ef70e77d56f24a41e886a161672.png";